"use client";
import { NotFoundPage } from "@/components/not-found/NotFoundPage";

export default function NotFound() {
  return <NotFoundPage />;
}
